(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
   const handleIntersection = (entries, observer) => {
     if (!entries[0].isIntersecting) return;
 
     observer.unobserve(productRecommendationsSection);
 
     const url = productRecommendationsSection.dataset.url;
 
     fetch(url)
       .then(response => response.text())
       .then(text => {
         const html = document.createElement('div');
         html.innerHTML = text;
         const recommendations = html.querySelector('.recommended-items');
         
         if (recommendations && recommendations.innerHTML.trim().length) {
           $('.recommended-products .cart-loader').hide();
           productRecommendationsSection.innerHTML = recommendations.innerHTML;

           getRecRatings();

           $(".recommended-products-slider").owlCarousel({
             nav: true,
             loop: false,
             rewind:true,
             dots:false,
             navSpeed: 800,
             margin: 10,
             navText : ['<div class="arrow-left"></div>','<div class="arrow-right"></div>'],
             responsive: {
                 0: {
                     items: 2
                 },
                 1199: {
                     items: 4        
                 }
             }
           });
 
         }
       })
       .catch(e => {
         console.error(e);
       });
   };
 
   const productRecommendationsSection = document.querySelector('.recommended-items');
   const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
 
   observer.observe(productRecommendationsSection);
 
  } catch(e) { console.error(e); }
})();
      })();
